<template>
  <div class="main-container">
    <bread-crumb :items="breadcrumbPath" />
    <v-divider />
    <v-flex
      md4
      sm6
      v-cloak
      xs12
    >
      <ManageEcsCompaniesTable />
    </v-flex>
  </div>
</template>

<script>

    import {mapGetters} from "vuex";
    import ManageEcsCompaniesTable from '@/views/ManageEcsCompanies/components/ManageEcsCompaniesTable.vue';

    export default {

        components: {
            ManageEcsCompaniesTable
        },

        data() {
            return {
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage ECS Companies', to: "manage-ecs-companies"}],
                loading: true,
                personnelWithEcsCompanyTitle: [],
                selectedPersonnelId: '',
                teamId: '',
                chosenPerson: {},

            };
        },

        computed: {
            ...mapGetters(
            [
                // "team",
                // "teamList",
                "editStateEcsCompany",
                // "personnelInEcsCompanyCount",
                // "personnelInEcsCompanyList",
            ]
            )
        },

        mounted() {
            // this.fetchPersonnel();

            // if (
            // this.$route.params !== undefined
            // && this.$route.params.teamId !== undefined) {
            //     this.teamId = this.$route.params.teamId;
            // }

            // if (this.teamId > 0) {
            //     this.fetchEcsCompany();
            // }
        },

        methods: {
            // fetchPersonnel() {
            //     this.$store.dispatch(FETCH_PERSONNEL);
            // },
            // fetchEcsCompany() {
            //     this.$store.dispatch(FETCH_TEAM, this.teamId);
            // },
        },


    }
</script>
